module.exports = __webpack_public_path__ + "files/aa3afb67c57c3d2c68789b1b95542932.svg";